module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "icon-linkedin.acf184b5.svg";